import { Box, Avatar, IconButton, Stack, Typography } from '@mui/material';
import { ChevronLeft, ChevronRight, X } from 'lucide-react';
import { Lucide } from '../../../../index';
import { useIsMobile } from '../../../../hooks';

interface AppointmentModalHeaderProps {
  onBack?: () => void;
  onClose?: () => void;
  t: (key: string) => string;
  logoSrc?: string;
  isLanding?: boolean;
  direction?: 'ltr' | 'rtl';
  step?: number;
}

export const AppointmentModalHeader: React.FC<AppointmentModalHeaderProps> = ({
  onBack,
  onClose,
  t,
  logoSrc,
  isLanding = false,
  direction = 'ltr',
  step,
}) => {
  const isMobile = useIsMobile();

  // Determine which prompt text to show
  const getPromptKey = () => {
    if (isLanding) {
      if (step === 1) {
        return 'selectDateTimePromptLandingStep1';
      }
      if (step === 2) {
        return 'selectDateTimePromptLandingStep2';
      }
      return 'selectDateTimePromptLanding';
    }
    if (step === 1) {
      return 'selectDateTimePromptStep1';
    }
    if (step === 2) {
      return 'selectDateTimePromptStep2';
    }
    return 'selectDateTimePrompt';
  };

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="flex-start"
      width="100%"
      position="relative"
    >
      {onBack && !isMobile && (
        <IconButton
          onClick={onBack}
          aria-label="Back"
          sx={{
            position: 'absolute',
            left: -20,
            top: -15,
          }}
        >
          <Lucide icon={direction === 'rtl' ? ChevronRight : ChevronLeft} />
        </IconButton>
      )}

      <Stack alignItems="center" spacing={2.5} width="100%">
        {logoSrc && isLanding && (
          <Stack width="100%" justifyContent="center" alignItems="center">
            <img
              src={logoSrc}
              style={{
                objectFit: 'contain',
                maxWidth: 'fit-content',
                height: '50px',
                // width: '250px',
              }}
            />
          </Stack>
        )}
        {logoSrc && !isLanding && (
          <Box
            component="img"
            src={logoSrc}
            alt="Logo"
            sx={{
              height: '35px',
              objectFit: 'contain',
              display: 'block',
            }}
          />
        )}

        <Stack spacing={1} alignItems="center" width="100%">
          <Typography variant="h6" fontWeight={600} textAlign="center" color="text.primary">
            {t('scheduling.appointment.bookOnlineTour')}
          </Typography>
          <Typography variant="body2" textAlign="center" color="text.secondary">
            {t(`scheduling.appointment.${getPromptKey()}`)}
          </Typography>
        </Stack>
      </Stack>
      {onClose && !isMobile && (
        <IconButton
          onClick={onClose}
          aria-label="Close"
          sx={{
            position: 'absolute',
            right: -20,
            top: -15,
          }}
        >
          <Lucide icon={X} />
        </IconButton>
      )}
    </Stack>
  );
};
